module.exports = __webpack_public_path__ + "img/14_bg.86ad0d0b.jpg";